import React from 'react';

const AppHeader = ({ products }) => {
    const totalProducts = products.length;
    const totalBrands = [...new Set(products.map(p => p.extracted_brand_name).filter(Boolean))].length;

    return (
        <header className="app-header">
            <div className="container">
                <div className="header-content">
                    <div className="brand-section">
                        <div className="logo-container">
                            <img src="/Logo.png" alt="BettrMatch Logo" className="app-logo" />
                            <div className="brand-text">
                                <h1>BettrMatch</h1>
                                <span className="platform-subtitle">Product Intelligence Platform</span>
                            </div>
                        </div>
                    </div>
                    <div className="header-stats">
                        <div className="stat-item">
                            <span className="stat-number">{totalProducts}</span>
                            <span className="stat-label">Products</span>
                        </div>
                        <div className="stat-item">
                            <span className="stat-number">{totalBrands}</span>
                            <span className="stat-label">Brands</span>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default AppHeader;
